import http from "./http";
import Service from "../Service";

/**
 * @type AuthenticationService
 */
export default class AuthenticationService extends Service {
    authenticate(credentials) {
        return http.post(`auth`, credentials, {
            headers: this.getHeaders(),
            timeout: 600000,
        });
    }
    requestReset(payload) {
        return http.post(`/password/request-reset`, payload, {
            headers: this.getHeaders(),
            timeout: 600000,
        });
    }
    newPassword(payload) {
        return http.post(`/password/reset`, payload, {
            headers: this.getHeaders(),
            timeout: 600000,
        });
    }
    validateToken(data) {
        return http.post(`/password/validate-token`, data, {
            headers: this.getHeaders(),
            timeout: 600000,
        });
    }
}
